import React from "react";
import { RegisterOptions } from "react-hook-form";
import { FormItem, SelectField } from "..";
import { SelectControlProps } from "./SelectControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function SelectControl(props: SelectControlProps) {
  const {
    defaultValue,
    getSelectFieldProps,
    hideHelperText,
    label,
    name,
    required,
    valuePropName,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {};
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    return result;
  }, [label, required]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getSelectFieldProps?.(params);
    },
    [getSelectFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      rules={rules}
      valuePropName={valuePropName}
    >
      <SelectField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(SelectControl);
